var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36661 1.10054C5.82619 0.48777 6.74534 0.487771 7.20492 1.10054L11.8007 7.22826C12.3688 7.98568 11.8283 9.06657 10.8815 9.06657H1.68998C0.743197 9.06657 0.202755 7.98568 0.770825 7.22825L5.36661 1.10054Z",
    fill: "#25C277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalTrack);
export default __webpack_public_path__ + "static/media/goal-track.ec432f20bba62231f3bdb0bb8bfd7bd5.svg";
export { ForwardRef as ReactComponent };